/* eslint-disable*/
import SurveyTestForm from '../surveyTestForm';

import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import GlobalContext from 'contexts';
import useFetchData from 'hooks/useFetchData';
import ExcelDownload from 'components/ExcelDownload';
import RedFlags from './redFlags';

export function SurveySummery({ clientProductUuid, handleChangeMode }) {
  const { globalProductInfo, currentCustomer } = useContext(GlobalContext);
  const [positiveQuestions, setPositiveQuestions] = useState(null);

  const questionPS = globalProductInfo.find(
    (pi) => pi?.productStage?.type === 'שאלון'
  )?.id;
  let { data: questionsData } = useFetchData(
    'client-survey-measures/getDoctorSummeryAndClientAnswers',
    questionPS
  );
  const [questions, setQuestions] = useState([]);
  let { data: surveySummeryHTML } = useFetchData(
    'client-survey-measures/getSurveySummeryHTML',
    clientProductUuid,
    'get',
    { enabled: !!clientProductUuid }
  );
  const [summeryData, setSummeryDate] = useState();

  useEffect(() => {
    if (surveySummeryHTML) setSummeryDate(surveySummeryHTML);
  }, [surveySummeryHTML]);

  useEffect(() => {
    if (questionsData?.questions?.length) {
      let obj = {};
      let questionsArr = [];
      obj.question = 'שם הלקוח';
      obj.answer = `${currentCustomer.first_name} ${currentCustomer.last_name}`;
      questionsArr.push(obj);
      obj = {};
      obj.question = 'ת.ז';
      obj.answer = `${currentCustomer.ssn}`;
      questionsArr.push(obj);
      questionsData.questions.forEach((q) => {
        if (q.answer !== '') {
          obj = {};
          obj.question = q?.question?.text;
          obj.category = q?.question?.categoryName;
          obj.answer = q.answer;
          questionsArr.push(obj);
        }
      });

      setPositiveQuestions(questionsData.summery);
      setQuestions(questionsArr);
    }
  }, [questionsData?.questions, questionsData?.summery]);
  return (
    <>
      <div>
        {summeryData ? (
          <div
            dangerouslySetInnerHTML={{
              __html: summeryData,
            }}
          ></div>
        ) : (
          <div className="summery-preview-loading">
            התצוגה המקדימה בטעינה… (ניתן לערוך ולשמור גם בזמן ההמתנה)
          </div>
        )}
        <RedFlags></RedFlags>

        <SurveyTestForm
          clientProductUuid={clientProductUuid}
          handleChangeMode={handleChangeMode}
          isSummery={true}
          positiveQuestions={positiveQuestions}
          doctorRecomends={questionsData?.recomends}
        ></SurveyTestForm>

        <div className="wrapper-actions-doctor">
          <div className="wrapper-questions">
            {questions && (
              <ExcelDownload
                data={questions}
                filename={'questions'}
                txtLink={'הורדת השאלון'}
              ></ExcelDownload>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

SurveySummery.propTypes = {
  clientProductUuid: PropTypes.string,
  handleChangeMode: PropTypes.func,
};
